/* global Swiper */

document.querySelectorAll( '.b-main-hero' ).forEach( ( block ) => {

	const swiperElement = block.querySelector( '.swiper' );

	if ( !swiperElement ) {

		return;

	}

	/**
	 * Equalize the height of all slides to match the tallest one.
	 */
	const equalizeSlideHeights = () => {

		const slides = swiperElement.querySelectorAll( '.swiper-slide' );

		if ( slides.length === 0 ) {

			return;

		}

		// Reset heights to auto to get natural heights
		slides.forEach( ( slide ) => {

			slide.style.height = 'auto';

		} );

		// Find the tallest slide
		let maxHeight = 0;
		slides.forEach( ( slide ) => {

			const slideHeight = slide.offsetHeight;
			if ( slideHeight > maxHeight ) {

				maxHeight = slideHeight;

			}

		} );

		// Apply max height to all slides
		slides.forEach( ( slide ) => {

			slide.style.height = `${maxHeight}px`;

		} );

	};

	const slides = swiperElement.querySelectorAll( '.swiper-slide' );
	const hasMultipleSlides = slides.length > 1;

	// Hide navigation arrows if there's only one slide
	if ( !hasMultipleSlides ) {

		const prevButton = block.querySelector( '.swiper-button-prev' );
		const nextButton = block.querySelector( '.swiper-button-next' );

		if ( prevButton ) {

			prevButton.style.display = 'none';

		}

		if ( nextButton ) {

			nextButton.style.display = 'none';

		}

	}

	new Swiper( swiperElement, {
		spaceBetween: 0,
		slidesPerView: 1,
		loop: hasMultipleSlides,
		navigation: hasMultipleSlides ? {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
			addIcons: false,
		} : false,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		on: {
			init: equalizeSlideHeights,
			resize: equalizeSlideHeights,
		},
	} );


} );
